import classNames from 'classnames';
import React from 'react';

type Props = {
    hasCroppedLogo: boolean;
    isSeriesParent: boolean;
    startDateTime: string;
    startMonthAbbr: string;
    startDay: string;
};

export const Header = ({
    hasCroppedLogo,
    isSeriesParent,
    startDateTime,
    startMonthAbbr,
    startDay,
}: Props) => {
    const wrapperClasses = classNames('listing-hero-header', {
        'hide-small': hasCroppedLogo,
        'hide-medium': hasCroppedLogo && isSeriesParent,
    });

    return (
        <div className={wrapperClasses}>
            <time
                id="listing-hero-date-desktop"
                className="listing-hero-date"
                dateTime={startDateTime}
            >
                <p className="listing-hero-image--month">{startMonthAbbr}</p>
                <p className="listing-hero-image--day">{startDay}</p>
            </time>
        </div>
    );
};
